import { FEATURE_FLAGS } from '../../core/config/feature-flags';
import { trebuieReamintitaActualizareaScolii } from '../../shared/utils/school-update-reminder';

interface SchoolUpdateStatus {
  needsUpdate: boolean;
  shouldHideMenuItems: boolean;
}

export function useSchoolUpdateCheck(
  userInfo: any,
  currentPath: string
): SchoolUpdateStatus {
  const CUTOFF_DATE = new Date(FEATURE_FLAGS.FORCE_SCHOOL_UPDATE.cutoffDate * 1000); // Convert Unix seconds to milliseconds

  const needsUpdate =
    FEATURE_FLAGS.FORCE_SCHOOL_UPDATE.enabled &&
    trebuieReamintitaActualizareaScolii(userInfo?.role, userInfo?.isEnabled, userInfo?.schoolUpdatedAt, CUTOFF_DATE);

  const shouldHideMenuItems = needsUpdate && currentPath !== '/detalii-scoala-v2';

  return { needsUpdate, shouldHideMenuItems };
}
